// SocketContext.jsx
import { createContext, useContext, useEffect, useState } from 'react';
import useUser from 'hooks/useUser';
import { connectSocket, disconnectSocket } from '../lib/socket';

const SocketContext = createContext(null);
export const SocketProvider = ({ children }) => {
  const user = useUser();
  const [socket, setSocket] = useState(null);
  useEffect(() => {
    if (user?.id) {
      const s = connectSocket();
      setSocket(s);
      return () => disconnectSocket();
    } else {
      disconnectSocket();
      setSocket(null);
    }
  }, [user?.id]);

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};

export const useSocket = () => useContext(SocketContext);
